<template>
  <div id="style4">
    <v-app>
      <v-row wrap v-if="records.length == 0">
        <v-col align="center" cols="12" md="12">
          <h3 class="red--text">No records found.</h3>
        </v-col>
      </v-row>
      <v-row justify="center" v-if="records.length > 0">
        <div v-for="item in records">
          <v-col cols="12">
            <div class="containers" v-on:click="previewData(item, $event)">
              <div class="box">
                <div class="members-cards">
                  <div class="members-cover" :style="item.StyleName">
                    <div class="members-cover-bg" :style="styles[i]"></div>
                    <img class="members-img" :src="item.PhotoPath" alt="" />
                    <div class="members-details">
                      <h1 class="members-title">{{ item.Fullname }}</h1>
                      <p class="members-subtitle">{{ item.DesignationName }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- {{ StyleIncrement() }} -->
            </div>
          </v-col>
        </div>
      </v-row>
    </v-app>
  </div>
</template>
<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";

export default {
  mixins: [common],
  props: {
    records: {
      required: true,
    },
  },
  data() {
    return {
      styles: [
        "background: linear-gradient(120deg, #f6d365 0%, #fda085 100%)",
        "background: linear-gradient(120deg, rgba(14,0,255,1) 0%, rgba(0,212,255,1) 100%)",
        "background: linear-gradient(120deg, rgba(255,0,0,1) 0%, rgba(255,222,0,1) 100%)",
        "background: linear-gradient(120deg, rgba(0,255,4,1) 0%, rgba(255,222,0,1) 100%);",
        "background: linear-gradient(120deg, rgba(0,255,4,1) 0%, rgba(0,223,255,1) 100%);",
        "background: linear-gradient(120deg, #f953c6 0%, #b91d73 100%);",
        "background: linear-gradient(120deg, #a8ff78 0%, #a8ff78 100%);",
        "background: linear-gradient(120deg, #CAC531 0%, #F3F9A7 100%);",
        "background: linear-gradient(120deg, #74ebd5 0%, #ACB6E5 100%);",
        "background: linear-gradient(120deg, #7F00FF 0%, #E100FF 100%);",
        "background: linear-gradient(120deg, #F2994A 0%, #F2C94C 100%);",
        "background: linear-gradient(120deg, #B2FEFA 0%, #0ED2F7 100%);",
        "background: linear-gradient(120deg, #F7971E 0%, #F7971E 100%);",
        "background: linear-gradient(120deg, #6190E8 0%, #6190E8 100%);",
        "background: linear-gradient(120deg, #4568DC 0%, #4568DC 100%);",
        "background: linear-gradient(120deg, #43C6AC 0%, #F8FFAE 100%);",
        "background: linear-gradient(120deg, #FFAFBD 0%, #ffc3a0 100%);",
        "background: linear-gradient(120deg, #f12711 0%, #f5af19 100%);",
        "background: linear-gradient(120deg, #3494E6 0%, #EC6EAD 100%);",
        "background: linear-gradient(120deg, #ee0979 0%, #ff6a00 100%);",
        "background: linear-gradient(120deg, #A770EF 0%, #FDB99B 100%);",
        "background: linear-gradient(120deg, #00c3ff 0%, #ffff1c 100%);",
        "background: linear-gradient(120deg, #ef32d9 0%, #89fffd 100%);",
        "background: linear-gradient(120deg, #56ab2f 0%, #a8e063 100%);",
        "background: linear-gradient(120deg, #00d2ff 0%, #928DAB 100%);",
        "background: linear-gradient(120deg, #FF5F6D 0%, #FFC371 100%);",
      ],
      getdata: 0,
      styleCount: 0,
      i: 0,
    };
  },
  components: {},
  mounted() {
    this.GetRecords();
  },
  methods: {
    GetRecords() {
      this.getdata = this.records.length;
      this.styleCount = this.styles.length;
      console.log(this.styleCount);
    },
    StyleIncrement() {
      this.i = this.i + 1;
      if (this.i == this.styleCount) {
        this.i = this.i - this.styleCount;
      }
    },
    previewData(tr, e) {
      console.log("previewData called");
      // var tr = this.selected
      // var n1 = tr.length
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        var id = tr.MemberId;
        // var id = 1;
        console.log("id=" + id);
        // var url = "/lom-single";
        var url = "/member-individual";
        var params = {
          id: id,
        };
        // this.$session.set("EditAwardsId", AwardsId);
        this.pageRedirect(params, url);
      } else {
        var message = "Kindly select one record to preview";
        this.toast("error", message);
      }
    },
  },
  beforeMount() {
    /*
            var user = this.$session.get("user");
            console.log("user=" + JSON.stringify(user));
            var rolecode = user == (null || undefined) ? "" : user.role_code;
            console.log("rolecode=" + rolecode);
            if(rolecode != 1){
                var message= "You could't access in this page."
                this.$router.push({ name: "home", params: { error: message } })
            } 
            */
  },
};
</script>

<style lang="scss">
#style4 {
  .containers {
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
    width: 160px;
    height: 300px;
    transform: rotateX(-11deg) rotateZ(0deg) rotateY(12deg) scale3d(1, 1, -0.9);
    margin: 10px 15px 10px 2.5vw;
  }

  .box {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .members-cards {
    display: flex;
    align-items: center;
    flex-direction: column;
    transition: all 0.3s ease-out;
    will-change: transform;
  }

  .box:hover .members-cards {
    transform: translateY(-14px) scale(1.04);
  }
  .members-cover {
    transition: all 400ms ease-in-out;
    width: 180px;
    box-shadow: inset 0 0 15px #fff;
    border-radius: 0px 40px 0px 40px;
  }

  .box .members-img {
    width: 75%;
    margin: 10% 0 0 13%;
    box-shadow: inset 0 0 25px #fff;
    border-radius: 0px 40px 0px 40px;
  }
  .members-cover-bg {
    z-index: -99;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 20px;
    left: -20px;
    display: block;
    opacity: 0;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 160px 214px;
    filter: blur(24px);
    transition: all 260ms ease-in-out;
    transform: scale(0.6);
    border-radius: 0px 40px 0px 40px;
  }

  .box:hover .members-cover .members-cover-bg {
    opacity: 0.8;
    transform: scale(1);
  }

  .members-details {
    margin-top: 5%;
    text-align: center;
  }
  .members-title {
    font-size: 16px;
    font-family: "Source Sans Pro", Helvetica, Arial, sans-serif;
    font-weight: 700;
    text-decoration: rgb(68, 68, 68);
    text-transform: uppercase;
    color: #ffffff;
    cursor: context-menu;
  }

  .members-subtitle {
    margin-top: -10px;
    font-family: Georgia, serif;
    font-size: 14px;
    letter-spacing: 0.4px;
    word-spacing: 0px;
    color: #000000;
    text-decoration: rgb(68, 68, 68);
    text-transform: capitalize;
    cursor: context-menu;
  }
}
</style>